import { render, staticRenderFns } from "./ItemCreateForm.vue?vue&type=template&id=393ec096&"
import script from "./ItemCreateForm.vue?vue&type=script&lang=js&"
export * from "./ItemCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports